module.exports = __webpack_public_path__ + "img/Frame 1063two.9fa61686.png";